export default "__VITE_ASSET__J40cIcX7__"